'use client';

import { ReactNode, useEffect, useRef, useState } from 'react';

interface RevealProps {
    children: ReactNode;
    className?: string;
    delay?: number;
}

const Reveal = ({ children, className = '', delay = 0 }: RevealProps) => {
    const ref = useRef<HTMLDivElement | null>(null);
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const node = ref.current;
        if (!node) return;

        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setIsVisible(true);
                    observer.disconnect();
                }
            },
            { threshold: 0.15 }
        );

        observer.observe(node);
        return () => observer.disconnect();
    }, []);

    return (
        <div
            ref={ref}
            style={{ transitionDelay: `${delay}ms` }}
            className={`motion-safe:transition-all motion-safe:duration-700 motion-safe:ease-out ${
                isVisible ? 'motion-safe:translate-y-0 motion-safe:opacity-100' : 'motion-safe:translate-y-6 motion-safe:opacity-0'
            } ${className}`}>
            {children}
        </div>
    );
};

export default Reveal;
